import '@babel/polyfill'
import './modules/gsap'
import './modules/menu-scroll'
import './modules/choices'
import './modules/flatpickr'
import './modules/swiper'
import GLightbox from 'glightbox'
import './modules/contact-form'
import './modules/bse-widget'

import { lazyLoading } from './modules/lazyload'
import { pageLoad } from './modules/page-loader'
import { menuScroll } from './modules/menu-scroll'
import { registerModal } from './modules/modal'
import { hamburgerAnimate } from './modules/hamburger'
import { registerCustomSelect } from './modules/custom-select'
import { registerTabPanel } from './modules/tab-panel'

registerCustomSelect()
lazyLoading()
pageLoad()
hamburgerAnimate()
registerTabPanel()

if (document.querySelector('.wp-block-gallery.has-nested-images')) {
  let figureTags = document.querySelectorAll(
    '.wp-block-gallery.has-nested-images figure'
  )

  figureTags.forEach((element, index) => {
    let image = element.firstChild

    let parentDiv = document.createElement('div')
    parentDiv.classList.add('mask-darken-link')

    let aTag = document.createElement('a')
    aTag.classList.add('glightbox', 'image')
    aTag.setAttribute('href', image.src)

    parentDiv.appendChild(aTag).appendChild(image)
    element.appendChild(parentDiv)
  })
}

const lightbox = GLightbox({
  touchNavigation: true,
  loop: true,
  autoplayVideos: false,
})
